import { get } from 'lodash';
import { createSelector } from 'reselect';
import queryString from 'query-string';

/**
 * Default selector used by SurveyTheme
 */

const selectThemeDomain = (state) => get(state, 'surveyTheme');

export const makeSelectActiveTheme = createSelector(
  selectThemeDomain,
  (state) => get(state, 'activeTheme', {}),
);

export const makeSelectActiveThemeUrlParams = createSelector(
  makeSelectActiveTheme,
  (activeTheme) =>
    queryString.stringify({
      ...activeTheme.settings,
      // we append the theme id so that the selector is re-calculated everytime the activeThemeId changes
      themeId: activeTheme.id,
    }),
);
export default makeSelectActiveTheme;
